import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from 'react-bootstrap';
import PatientsImage from './PatientsImage';
import {appConfig} from '../../../config';
import '../../Common/Common.css';
import ModalImage from 'react-modal-image';
import ReactPaginate from 'react-paginate';
var dateFormat = require('dateformat');
class PatientsViewModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientsImgModal: false,
      itempage: 0,
      itemsperPage: 5,
    };
    this.mouseOver = this.mouseOver.bind(this);
  }

  mouseOver = data => {
    this.setState({patientsImgModal: true, ImageData: data});
  };

  closeImgModel = () => {
    this.setState({patientsImgModal: false});
  };

  itemsPageClick = ev => {
    const selecteditemPage = ev.selected;
    this.props.itempageSelected({
      item: this.props.patientuserDtls,
      page: selecteditemPage + 1,
    });
    this.setState({itempage: selecteditemPage});
  };

  resetitemPage = () => {
    //For resetting the itemdetail table to page 1 in pagination
    this.setState({
      ...this.state,
      itempage: 0,
    });
  };

  render() {
  const { itempage, itemsperPage } = this.state;
  const { patientsprscrptnlsCount, ItemCount } = this.props;

  const itemcount =
    this.props.patientsprscrptnlsCount && this.props.patientsprscrptnlsCount;
  let p1 = itempage + 1;
  let itemPageCount = Math.ceil(itemcount / itemsperPage);

  const data =
    this.props.patientuserDtls && this.props.patientuserDtls.item
      ? this.props.patientuserDtls.item
      : null;

  const datas = this.props.patientsmainDtls || null;
  const item = this.props.patientsprscrptnls || null;


    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            className="chemistmodeldiv"
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Profile Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body  style={{fontSize: '15px'}}>
              <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div className="chemistdetails">
                    {/* <p className="chemistdetailspera">
                      {data !== null && data.name}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.mobileNo}
                    </p>
                    <p className="chemistdetailspera">
                      {datas !== null && datas.email}
                    </p>
                    <p className="chemistdetailspera">
                      {datas !== null && datas.addr}
                    </p>
                    <p className="chemistdetailspera">
                      {datas !== null && datas.city}
                    </p> */}

                    <p>
                      <span className="cmn_Cap"> Name : </span>{' '}
                      {data !== null && data.name}
                      <br />
                      <span className="cmn_Cap"> Mobile : </span>{' '}
                      {data !== null && data.mobileNo}
                      <br />
                      <span className="cmn_Cap"> Email : </span>{' '}
                      {datas !== null && datas.email}
                      <br />
                      <span className="cmn_Cap"> Address : </span>{' '}
                      {datas !== null && datas.addr}
                      {/* <br />
                      <span className="cmn_Cap"> City : </span>{' '}
                      {datas !== null && datas.city} */}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={4} lg={4} />
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    {/* <p className="chemistdetailspera">
                      {datas !== null &&
                        datas.state !== undefined &&
                        datas.state.name}
                      ,{' '}
                      {datas !== null &&
                        datas.district !== undefined &&
                        datas.district.name}
                    </p>
                    <p className="chemistdetailspera">
                      {datas !== null && datas.landmark}
                    </p>

                    <p className="chemistdetailspera">
                      {datas !== null && datas.zip}
                    </p>
                    <p className="chemistdetailspera">
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, 'dd-mmm-yyyy')
                        : null}
                    </p> */}

                    <p>
                      <span className="cmn_Cap"> City : </span>{' '}
                      {datas !== null && datas.city},{' '}
                      {datas !== null &&
                        datas.state !== undefined &&
                        datas.state.name}
                      ,{' '}
                      {datas !== null &&
                        datas.district !== undefined &&
                        datas.district.name}
                      <br />
                      <span className="cmn_Cap"> Landmark : </span>{' '}
                      {datas !== null && datas.landmark}
                      <br />
                      <span className="cmn_Cap"> Pincode : </span>{' '}
                      {datas !== null && datas.zip}
                      <br />
                      <span className="cmn_Cap"> Created Date : </span>{' '}
                      {data !== null && data.createdAt
                        ? dateFormat(data.createdAt, 'dd-mmm-yyyy')
                        : null}
                    </p>
                  </div>
                </Col>
              </Row>

              <hr />
              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h4>Prescription Info</h4>
                </Col>

                <Col xs={12} sm={12} md={3} lg={3} />
                <Col xs={12} sm={12} md={3} lg={3} />

                <Col xs={12} sm={12} md={3} lg={3}>
                  <div>
                    <span className="cmnPageCount">
                      {' '}{/* {itemcount !== undefined ? itemcount : 0} */}
                      {itemcount !== undefined ? itemcount : 0}
                    </span>
                    <span className="cmnResutText">Results</span>
                  </div>
                </Col>
              </Row>

              <Table responsive bordered className="cmnMainTable">
                <thead>
                  <tr>
                    <th> Patient Name </th>
                    <th>Doctor Name </th>
                    <th>Prescription Notes </th>
                    <th>Prescription Image </th>
                    <th>Prescription Date </th>
                    <th>Status </th>
                  </tr>
                </thead>
                {this.props.patientsprscrptnls !== undefined &&
                  this.props.ItemCount !== 0 &&
                  this.props.patientsprscrptnls &&
                  this.props.patientsprscrptnls.map((item, i) =>
                    <tbody>
                      {/* {this.props.patientsprscrptnls &&
                    this.props.patientsprscrptnls.map((item, i) => ( */}
                      <tr key={i}>
                        {/* <th scope="row">{5 * (p1 - 1) + i + 1}</th> */}
                        <td>
                          {item !== null && item.patientName}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.doctorName}
                        </td>
                        <td>
                          {' '}{item !== null && item.prscrptnTag
                            ? item.prscrptnTag
                            : <span style={{fontStyle: 'italic'}}>
                                -No notes provided -
                              </span>}
                        </td>

                        <td className="centerAlign">
                          {item && item.prcptImg
                            ? <ModalImage
                                small={
                                  item &&
                                  item.prcptImg &&
                                  appConfig.imgServerip +
                                    `/prescriptn?imgName=${item.prcptImg}`
                                }
                                large={
                                  item &&
                                  item.prcptImg &&
                                  appConfig.imgServerip +
                                    `/prescriptn?imgName=${item.prcptImg}`
                                }
                                hideDownload={true}
                                hideZoom={true}
                                className="imageModalClass"
                              />
                            : 'Preview not available'}
                          {/* <PatientsImage
                            show={this.state.patientsImgModal}
                            handleClose={this.closeImgModel}
                            ImageData={this.state.ImageData}
                          /> */}
                        </td>
                        <td>
                          {item !== null &&
                            item.prscrptnDate !== null &&
                            item.prscrptnDate !== undefined &&
                            dateFormat(item.prscrptnDate, 'mediumDate')}
                        </td>
                        <td>
                          {item !== null && item.status === 'active'
                            ? 'Active'
                            : 'Inactive'}
                        </td>
                      </tr>
                      {/* ))} */}
                    </tbody>
                  )}
              </Table>

              {itemPageCount > 1
                ? <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={itempage}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={itemPageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={this.itemsPageClick}
                      containerClassName={'pagination flex-wrap'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  </div>
                : null}
              {(this.props.patientsprscrptnls === undefined ||
                (this.props.patientsprscrptnls &&
                  this.props.patientsprscrptnls.length === 0)) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">No Data Found</div>
                </div>}
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#f0f3f5'}} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientsViewModel;
